import React, { useState } from "react";
import { BaseModal } from "../../atoms/base-modal";
import classnames from "classnames";

type FileType = {
  name: string;
  data: string;
};

export const CsvUploadModal: React.FC<{
  isActive: boolean;
  procedureName: string;
  onClose: () => void;
  onClick: (file: FileType) => void;
}> = ({ isActive, procedureName, onClose, onClick }) => {
  const [file, setFile] = useState<FileType | undefined>();

  return (
    <BaseModal
      title={"CSVで複数の申請を選択する"}
      isActive={isActive}
      onClose={onClose}
    >
      <section className="modal-card-body">
        <div className="file has-name">
          <label className="file-label">
            <input
              className="file-input"
              type="file"
              name="resume"
              accept="text/csv"
              onChange={(e) => {
                const fileReader = new FileReader();
                const fileDropped = e.target.files![0];
                if (!fileDropped) {
                  return;
                }
                fileReader.onload = function () {
                  const dataUri = this.result as string;
                  setFile({
                    name: fileDropped.name,
                    data: dataUri.split(",")[1],
                  });
                };
                fileReader.readAsDataURL(fileDropped);
              }}
            />
            <span className="file-cta">
              <span className="file-icon">
                <i className="fas fa-upload" />
              </span>
              <span className="file-label">
                {file ? file.name : "ファイルを選択…"}
              </span>
            </span>
            <span className="file-name">{file ? "選択済み" : "未選択"}</span>
          </label>
        </div>
        <div className="notification mt-2">
          <ul>
            <li>{`「${procedureName}」の申請のみを選択してください。`}</li>
            <li>
              ダウンロードした申請一覧CSVから申請番号列のみにしたCSVをアップロードしてください。
            </li>
            <li>
              1 度に最大 <strong>500</strong> 件の申請を選択できます。
            </li>
          </ul>
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onClose}>
          キャンセル
        </button>
        <button
          className={classnames("button is-info is-fullwidth")}
          onClick={() => onClick(file!)}
          disabled={!file}
        >
          選択する
        </button>
      </footer>
    </BaseModal>
  );
};
